import { NavLink, useLocation, Link } from 'react-router';
import { Plus } from 'lucide-react';
import { Sidebar, SidebarContent, SidebarGroup, SidebarGroupContent, SidebarGroupLabel, SidebarHeader, SidebarMenu, SidebarMenuButton, SidebarMenuItem, SidebarRail, useSidebar } from '@/components/ui/sidebar';
import { Button } from '@/components/ui/button';
import { useBusiness } from '@/lib/business';
import { BusinessSwitcher } from './business-switcher';
import { NAV } from './nav';

/** The product mark: a ledger, not a logo-in-a-box. */
export function Wordmark() {
  return (
    <div className="flex items-center gap-2 px-2 pt-1 group-data-[collapsible=icon]:justify-center">
      <img src="/favicon.svg" alt="" className="size-5 rounded-[4px]" />
      <span className="text-sm font-semibold tracking-tight text-foreground group-data-[collapsible=icon]:hidden">Business Portal</span>
    </div>
  );
}

export function AppSidebar() {
  const { can } = useBusiness();
  const { pathname } = useLocation();
  const { setOpenMobile, state } = useSidebar();
  const isActive = (to: string, end?: boolean) => (end ? pathname === to : pathname === to || pathname.startsWith(`${to}/`));

  return (
    <Sidebar collapsible="icon" aria-label="Main navigation">
      <SidebarHeader className="gap-3 p-3">
        <Wordmark />
        <BusinessSwitcher />
        {can('invoice:write') && (
          <Button asChild variant="secondary" size={state === 'collapsed' ? 'icon-sm' : 'default'} className="group-data-[collapsible=icon]:size-8" onClick={() => setOpenMobile(false)}>
            <Link to="/invoices/new" aria-label="New invoice">
              <Plus aria-hidden />
              <span className="group-data-[collapsible=icon]:hidden">New invoice</span>
            </Link>
          </Button>
        )}
      </SidebarHeader>
      <SidebarContent className="gap-1 px-1.5">
        {NAV.map((group) => {
          const items = group.items.filter((i) => !i.permission || can(i.permission));
          if (items.length === 0) return null;
          return (
            <SidebarGroup key={group.label} className="py-1.5">
              <SidebarGroupLabel>{group.label}</SidebarGroupLabel>
              <SidebarGroupContent>
                <SidebarMenu className="gap-0.5">
                  {items.map((item) => (
                    <SidebarMenuItem key={item.to}>
                      <SidebarMenuButton asChild isActive={isActive(item.to, item.end)} tooltip={item.label}>
                        <NavLink to={item.to} end={item.end} onClick={() => setOpenMobile(false)}>
                          <item.icon aria-hidden />
                          <span>{item.label}</span>
                        </NavLink>
                      </SidebarMenuButton>
                    </SidebarMenuItem>
                  ))}
                </SidebarMenu>
              </SidebarGroupContent>
            </SidebarGroup>
          );
        })}
      </SidebarContent>
      <SidebarRail />
    </Sidebar>
  );
}
